import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table, Spinner, Alert } from 'react-bootstrap'
import { projectsAPI } from '../../services/api'
import LongPressRow from './LongPressRow'

const ProjectsList = () => {
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [actionTarget, setActionTarget] = useState(null)

  useEffect(() => {
    loadProjects()
  }, [])

  const loadProjects = async () => {
    try {
      setLoading(true)
      const response = await projectsAPI.list()
      setProjects(response.data)
      setError(null)
    } catch (err) {
      setError('Ошибка загрузки проектов')
      console.error('Error loading projects:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleLongPress = (rect, projectId) => {
    setActionTarget({ id: projectId, top: rect.top, height: rect.height })
  }

  const handleArchive = async () => {
    const id = actionTarget.id
    setActionTarget(null)
    setProjects(prev => prev.filter(p => p.id !== id))
    try {
      await projectsAPI.archive(id)
    } catch (err) {
      console.error('Error archiving project:', err)
      loadProjects()
    }
  }

  const handleDismiss = () => setActionTarget(null)

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner animation="border" />
      </div>
    )
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="mb-0">Проекты</h1>
        <Link to="/projects/new" className="btn btn-primary btn-sm">
          Создать новый проект
        </Link>
      </div>

      {projects.length === 0 ? (
        <Alert variant="info">Нет проектов</Alert>
      ) : (
        <div className="table-responsive">
          <Table striped hover>
            <thead className="table-dark">
              <tr>
                <th>№</th>
                <th>Договор</th>
                <th>Адрес объекта</th>
                <th>Заказчик</th>
              </tr>
            </thead>
            <tbody>
              {projects.map((project, index) => (
                <LongPressRow
                  key={project.id}
                  active={actionTarget?.id === project.id}
                  onComplete={(rect) => handleLongPress(rect, project.id)}
                >
                  <td>{index + 1}</td>
                  <td>
                    <Link to={`/projects/${project.id}`} className="text-decoration-none">
                      {project.contract_number}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/projects/${project.id}`} className="text-decoration-none">
                      {project.address}
                    </Link>
                  </td>
                  <td>{project.customer_name}</td>
                </LongPressRow>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {actionTarget && (
        <>
          <div className="lp-backdrop" onClick={handleDismiss} />
          <div
            className="lp-action-bar"
            style={{ top: actionTarget.top, height: actionTarget.height }}
          >
            <span className="lp-action-bar__label">В архив?</span>
            <button className="lp-action-bar__btn lp-action-bar__btn--confirm" onClick={handleArchive}>
              В архив
            </button>
            <button className="lp-action-bar__btn lp-action-bar__btn--cancel" onClick={handleDismiss}>
              Отмена
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default ProjectsList
